import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Button } from 'localmed-core';

import { openingShape } from '../../../legacyCore/OpeningsCalendar';
import { WIDGET_SCHEDULING } from '../../constants';
import CalendarTime from '../CalendarTime';
import WidgetLink from '../WidgetLink';
import { SchedulingSessionStateContext } from '../SchedulingSessionState';
import { withRouterPropTypes } from '../../shapes';
import { buildOpeningUrl } from '../../utils/urls';

const FirstAvailableOpening = ({
  opening,
  timeZone,
  match,
  location,
  history,
  staticContext,
  ...props
}) => {
  const { widgetSettings } = useContext(SchedulingSessionStateContext);
  const openingUrl = buildOpeningUrl(opening.provider.id, opening.id, {
    location: history.location,
  });
  return (
    <WidgetLink
      {...props}
      data-qa="first-available-opening"
      component={Button}
      href={openingUrl}
      toWidget={widgetSettings.scheduling === WIDGET_SCHEDULING.IN_WIDGET}
      tier="alert"
    >
      <span>
        First Available: <CalendarTime datetime={opening.time} timeZone={timeZone} />
      </span>
    </WidgetLink>
  );
};

FirstAvailableOpening.propTypes = {
  ...withRouterPropTypes,
  opening: openingShape.isRequired,
  timeZone: PropTypes.string,
  isOnWidget: PropTypes.bool.isRequired,
};

export default withRouter(FirstAvailableOpening);
